import React, { Suspense, useEffect, useState } from "react";
import RenewHealthCard from "./common/RenewHealthCard";
import Warning from "../common/Warning";
import ViewPayment from "../common/ViewPayment";
import { SlamaRequestTypes } from "../../utils/constants";
import { fetchTranslationData } from "../../services/translation/translation";
import { ServiceTranslation } from "../../utils/constants";

import RenewHealthModal from "./common/RenewHealthModal";
import { getHeadlthCardInfo } from "../../services/rhapsody/RenewHealthCard";
import {
  configureFirstIframe,
  getLayoutDirection,
  isMobileApp,
  reloadOnBrowserBack, updateThePlanNewName } from
"../../utils/util";
import { Loader } from "../../common/Loader";

function dateFormat(date) {
  let res = "";
  if (date) {
    let [year, month, day] = date.split("-");
    res = `${day}/${month}/${year}`;
  }
  return res;
}

const RenewCoverage = () => {
  const [renewCoverageData, setRenewCoverageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [translationMap, setTranslationMap] = useState(null);
  // const [isInprogress, setIsInprogress] = useState(false);
  const [isPaymentProgress, setIsPaymentProgress] = useState(false);
  const [, setIsValidEid] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [cardNumber, setCardNumber] = useState(null);
  const [isInitated, setIsInitated] = useState(false);
  const [isExpiredEpd, setIsExpiredEpd] = useState(false);
  const [listexpiredAndNotEligiblePlans, setListexpiredAndNotEligiblePlans] = useState([]);
  const [listEpdExired, setListEpdExired] = useState([]);
  useEffect(() => {
    setLoading(true);
    reloadOnBrowserBack();
    window.parent.scrollTo(0, 0);
    getHeadlthCardInfo()
    .then((response) => {

      const healthRes = response.data;
      if (healthRes) {
        const { patientInfo, resultCoverage } = response.data;
        const { fullName = '' } = patientInfo;
        const [lastName = '', firstName = ''] = fullName.split(',');
        patientInfo.fullName = `${firstName.trim()} ${lastName.trim()}`;
        setUserInfo(patientInfo);
        setRenewCoverageData(resultCoverage);
        if (resultCoverage.length > 3) {
          configureFirstIframe(200, 2550, true);
        }
        setIsValidEid(patientInfo.isValidEid);
        if (resultCoverage.length > 0) {
          const expiredAndNotEligiblePlans = resultCoverage
          .filter((plan) => !plan.isEligibileForOnlineRenewal && plan.coverageStatus === "Expired")
          .map((plan) => updateThePlanNewName(plan.payor_value, plan.plan_name, translationMap));
          setListexpiredAndNotEligiblePlans(expiredAndNotEligiblePlans);

          const expiredAndEpd = resultCoverage
          .filter((plan) => plan.coverageStatus === "Expired")
          .map((plan) => updateThePlanNewName(plan.payor_value, plan.plan_name, translationMap));
          setListEpdExired(expiredAndEpd);



        }


        const anyInitiated = resultCoverage?.some((cov) => cov.paymentStatus === "INITIATED");
        setIsInitated(anyInitiated);
        if (patientInfo && patientInfo.isMarkedEpd) {
          const isAnyExpiredEpd = resultCoverage?.some((cov) => cov.coverageStatus === "Expired");
          setIsExpiredEpd(isAnyExpiredEpd);
        }
        setLoading(false);
      }
    })
    .catch((err) => {
      console.error("Error fetching health card info:", err);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.HealthCardInfo).then((result) => {
      setTranslationMap(result);
    });
  }, []);

  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const handleRenewCard = (index) => {
    setCardNumber(index);
    setShowPaymentModal(true);
  };

  if (loading) return <Loader />;
  if (isPaymentProgress) return <Loader />;

  return (
    <div className={` custombody_color ${getLayoutDirection()}`}>

            <section
        className="w-100 clearfix RenewCoveragePlanSection CoverPlanAlertBx"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    {!isMobileApp() &&
          <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">{translationMap?.renewHealthCard}</h6>
                        </div>
          }

                    <div className="cover_inner_wrapper cover_inner_wrapper2">

                        <div className="cover_main_box1">
                            {userInfo.isMarkedEpd && isExpiredEpd &&
              <Warning desc={
              <>
                                        {translationMap?.notEligiblRreason}
                                        <br />
                                        {listEpdExired?.length > 1 &&
                listEpdExired.map((plan, index) =>
                <span key={index}>
                                                            {`• ${plan}`}
                                                    <br />
                                                          </span>
                )}
                                    </>
              }
              heading={translationMap?.coveragePlanRenewal}> </Warning>
              }
                            {
              !userInfo.isMarkedEpd && listexpiredAndNotEligiblePlans.length > 0 &&
              <Warning
                desc={
                <>
                                                {translationMap?.notEligiblRreason}
                                                <br />
                                                {listexpiredAndNotEligiblePlans?.length > 1 &&
                  listexpiredAndNotEligiblePlans.map((plan, index) =>
                  <span key={index}>
                                                            {`• ${plan}`}
                                                            <br />
                                                          </span>
                  )}
                                            </>
                }
                heading={translationMap?.coveragePlanRenewal} />


              }
                            {isInitated &&
              <Warning
                desc={translationMap?.renewHealthInitiatedPayment}
                heading={translationMap?.renewHealthInitiatedPaymentMessage} />
              }
                            {
              renewCoverageData && renewCoverageData.length > 0 ?
              renewCoverageData.map((coverage, index) => {
                return <RenewHealthCard
                  index={index}
                  status={coverage.coverageStatus}
                  mrn={userInfo.mrn}
                  mobileNumber={userInfo.mobileNumber}
                  emiratesId={userInfo.emiratesId}
                  coveragePlanName={coverage.plan_name}
                  coveragePayorCode={coverage.payor_value}
                  expiryDate={dateFormat(coverage.period_end)}
                  fullName={userInfo.fullName}
                  handleRenewCard={handleRenewCard}
                  translationMap={translationMap}
                  paymentStatus={coverage.paymentStatus}
                  isEligibile={coverage.isEligibileForOnlineRenewal}
                  isValidEid={userInfo.isValidEid}
                  isMarkedEpd={userInfo.isMarkedEpd} />;

              }) :



              <>
                                            <Warning
                  desc={translationMap?.noPlanFoundDesc}
                  heading={translationMap?.noPlanFound} />
                
                                        </>

              }

                        </div>
                        <div className="cover_main_box2">
                            {renewCoverageData &&
              <ViewPayment
                to={`/payment-history/${SlamaRequestTypes.healthCardRenewal}`}
                translationMap={translationMap} />

              }
                        </div>
                    </div>

                    {showPaymentModal &&
          <Suspense fallback={<Loader />}>
                            <RenewHealthModal
              show={showPaymentModal}
              close={closePaymentModal}
              data={userInfo}
              setShowPaymentModal={setShowPaymentModal}
              translationMap={translationMap}
              setIsPaymentProgress={setIsPaymentProgress}
              cardNumber={cardNumber}
              isValidEid={userInfo.isValidEid} />

            
                        </Suspense>
          }
                </div>
            </section>
        </div>);

};

export default RenewCoverage;